import React from 'react';
import PropTypes from 'prop-types';
// TODO: `href` value should be coming from the props
const BackLink = ({ goBack, children }) => {
  if (typeof children === 'string') {
    return <a href="/" onClick={(e) => { e.preventDefault(); goBack(); }}>{ children }</a>;
  }

  return React.cloneElement(
    children,
    { goBack }
  );
};

BackLink.propTypes = {
  goBack: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
};

export default BackLink;

